<template>
  <div class="container">
    <Title-b :title="$t('Side.ddgz')" />
    <p class="userP">{{$t('Domesticordertracking.logisticsinformation')}}</p>
    <div class="all">
      <!-- imput -->
      <div class="search">
        <i-input placeholder="" v-model="searchValue" style="width: 343px"></i-input>
        <i-button type="error" class="search_error" @click="GetLogisticsTrajectory" style="color:#000;">搜索</i-button>
        <img src="../../../assets/images/sousuo1.png" alt="">
      </div>
      <div v-for="(item,index) in allorder" :key="index">{{item}}</div>
      <!-- 处理时间 -->
      <div class="date">
        <div>
          <i-table stripe :columns="columns1" :data="arr.length ?arr[0].value : []" align="center" id="mygrid"></i-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        columns1: [{
            title: '處理時間',
            key: 'scan_time'
          },
          {
            title: '處理信息',
            key: 'scan_memo'
          }
        ],
        userObject:[
          {
           img:require('../../../assets/images/tijiao.png'),
           name:"提交訂單",
           img1:require('../../../assets/images/gouxuan1.png')
          },
          {
           img:require('../../../assets/images/ruku.png'),
           name:"包裹入庫",
           img1:require('../../../assets/images/gouxuan1.png')
          },
          {
           img:require('../../../assets/images/baoguochuku.png'),
           name:"包裹出庫",
           img1:require('../../../assets/images/gouxuan1.png')
          },
          {
           img:require('../../../assets/images/qianshou.png'),
           name:"簽收"
          },
          {
           img:require('../../../assets/images/gouxuan.png'),
           name:"訂單完成"
          }
        ],
        allorder:[],
        arr: [],
        searchValue: ''
      }
    },
    methods:{
      // 参数{
      //   billcodelist: searchValue,token
      //   }
      // 2086102317
      async GetLogisticsTrajectory(){
          let _this= this;
          const params = {
            MemberID:localStorage.getItem("userID"),
            billcodelist: _this.searchValue,
            token: localStorage.getItem("token")
          };
          const { data } = await this.$post("GetLogisticsTrajectory",params,true);
          if(data.State){
            this.allorder = JSON.parse(data.ReturnJson);
          }
          _this.arr = []
          let obj = JSON.parse(data.ReturnJson);
          Object.keys(obj).forEach((key,index) => {
            _this.arr.push({
            name: key,
            value : JSON.parse(obj[key])
          })
        })
      }
    },
    mounted(){
    }
    // created() {
    //   document.getElementsByClassName('background_one').htmlText="wwww"
    // }
  }
</script>
<style lang="scss" scoped>
  .container {
    width: 1069px;
    height: 748px;
    background: #fff;
    padding: 20px 29px;

    // 修改table的属性
    /deep/ #mygrid{
      width: 1029px;
      .ivu-table th{
        text-align: center;
        background: #E2E2E2;
      }
      .ivu-table td{
        text-align: center;
        height: 30px;
      }
      // .ivu-table tr:nth-child(odd){
      //   background-color: red;
      // }
      // .ivu-table tr:nth-child(even){
      //   background-color: #000;
      // }
    }
    .userP {
      color: #ccc;
      font-size: 14px;
      font-weight: 400;
      padding: 15px 0 0 61px;
    }

    .all {
      width: 100%;
      display: flex;
      flex-direction: column;
      height: 1000px;

      .search {
        height: 52px;
        margin: 20px 0 0 265px;
        position: relative;
        .search_error {
          width: 80px;
          height: 30px;
          //  @include border($_color);
          @include backgroundColor($_color);
          // background: #FF0000;
          color: #fff !important;
          margin-left: 10px;

        }
        /deep/ .ivu-btn-error{
          border-color: #fff;
        }

        /deep/ .ivu-input{padding-left: 39px !important;}
         /deep/ .ivu-input::-webkit-input-placeholder{
              color:#999;
              padding-left: 30px;
         }
        img{
          position: absolute;
          left: 13px;top: 6px;
        }
      }
      .date {
        width: 1029px;
        margin: 30px 0 0 -9px;
        border: 1px solid #CCCCCC;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/view/homeManage/Ordertracking.vue